import { defineComponent, ref, onMounted } from 'vue'
import MapPage from '@/organizations/_default/map'
import FilterInfo from '@/organizations/crecia/default/components/FilterInfo.vue'
import ProductModal from '@/organizations/crecia/default/components/ProductModal.vue'
import { Filters } from '@/services/Filters.ts'

export default defineComponent({
  extends: MapPage,
  components: {
    FilterInfo,
    ProductModal
  },
  setup(props, context) {
    const page = MapPage.setup(props, context)

    const selectedProduct = ref({})
    const productModalRef = ref(null)

    onMounted(() => {
      setTimeout(() => {
        const elements = document.querySelectorAll('.filter-info')
        elements.forEach(element => {
          const filterId = element.dataset.filterId
          element.addEventListener('click', () => {
            selectedProduct.value = Filters.findById(Filters.TYPE_SEARCH_CONDITIONS, filterId)
            productModalRef.value.open()

            storelocator.analytics.client?.send('SelectProductInfo', {
              ProductId: selectedProduct.value.id,
              ProductName: selectedProduct.value.name,
            })
          })
        })
      }, 100)
    })

    return {
      ...page,
      selectedProduct,
      productModalRef
    }
  }
})
